export default class PointOfInterest
{
  constructor(names, descriptions, categories, latitude, longitude) 
  {
    this.names = names; // {} instead of array to support stringify
    this.descriptions = descriptions;
    this.categories = categories;
    this.latitude = latitude;
    this.longitude = longitude;
  }    

  isValid()
  {
    var result = true;

    // Names
    for (const [key, value] of Object.entries(this.names)) {
      if(!value)
      {
        result = false;
        break;
      };
    }

    // Description
    if(result)
    {
      for (const [key, value] of Object.entries(this.descriptions)) {
        if(!value)
        {
          result = false;
          break;
        };
      }
    }

    // Categories
    if(result)
    {
      result = Array.isArray(this.categories) && this.categories.length;
    }

    // Latitude and longitude
    if(result)
    {
      result = this.latitude && this.longitude;
    }

    return result;
  }
}